import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import InfoIcon from '@mui/icons-material/Info';
import { Link, useNavigate } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';
import { ProfileContext } from '../context/ProfileContext';
import axiosInstance from '../axiosConfig';

// Material-UI Icons
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsIcon from '@mui/icons-material/Settings';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';


const pages = {
    // 'Home': './pages/Home',
    // 'Konfigurator': './pages/QuestionForm'
};

function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [schoolProfile, setSchoolProfile] = React.useState(null);
  const { userProfile, userRole, setUserProfile, setUserRole } = React.useContext(ProfileContext);
  const navigate = useNavigate();

  React.useEffect(() => {
    setAnchorElUser(null); // Menü schließen, wenn sich userProfile oder userRole ändert
  }, [userProfile, userRole]);

  // Prüfe, ob der Benutzer eingeloggt ist
  const isLoggedIn = !!localStorage.getItem('authToken');

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = async () => {
  try {
    // Logout-Request an das Backend senden
    await axiosInstance.post('/auth/logout', {}, { withCredentials: true });

    // Auth-Token aus localStorage entfernen
    localStorage.removeItem('authToken');

    // Nutzerprofile und Rolle zurücksetzen
    setUserProfile(null);
    setUserRole(null);

    // Nutzer zum Login weiterleiten
    navigate('/pages/logout'); 
  } catch (error) {
    console.error('Fehler beim Logout:', error);
  }
};


  return (
    <AppBar position="static" sx={{ backgroundColor: '#38629F' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              <MenuItem component={Link} key='Home' onClick={handleCloseNavMenu}>
                <Typography sx={{ textAlign: 'center' }}>Home</Typography>
              </MenuItem>
            </Menu>
          </Box>

          <Box
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <img
              src="/uploads/images/Logo-Schullogbuch24-white-300x49.png"
              alt="Schullogbuch24 Logo"
              style={{ height: '49px', width: 'auto' }}
            />
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {Object.entries(pages).map(([pageName, path]) => (
              <Button
                component={Link}
                to={path}
                key={pageName}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {pageName}
              </Button>
            ))}
          </Box>
          {!isLoggedIn && (
              <Button
                component={Link}
                to='/pages/login'
                startIcon={<LoginIcon />}
                sx={{ my: 2, color: 'white' }}
                data-testid="login-button"
              >
                Login
              </Button>
            )}

          {/* Profile Menu wird nur angezeigt, wenn der Benutzer eingeloggt ist */}
          {isLoggedIn && (
            <Box className="profileMenu" sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="User Avatar" src={userProfile?.profileImageUrl || schoolProfile?.logoUrl} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem component={Link} key="Benutzerprofil" onClick={handleCloseUserMenu} to="/pages/user-profile">
                  <PersonIcon sx={{ mr: 1, color: 'rgba(0, 0, 0, 0.54)' }} />
                  <Typography sx={{ textAlign: 'center' }}>Benutzerprofil</Typography>
                </MenuItem>

                <MenuItem component={Link} key="Schulprofil" onClick={handleCloseUserMenu} to="/pages/school-profile">
                  <SchoolIcon sx={{ mr: 1, color: 'rgba(0, 0, 0, 0.54)' }} />
                  <Typography sx={{ textAlign: 'center' }}>Schulprofil</Typography>
                </MenuItem>

                <MenuItem component={Link} key="Sicherheitseinstellungen" onClick={handleCloseUserMenu} to="/pages/security">
                  <SecurityIcon sx={{ mr: 1, color: 'rgba(0, 0, 0, 0.54)' }} />
                  <Typography sx={{ textAlign: 'center' }}>Sicherheitseinstellungen</Typography>
                </MenuItem>

                <MenuItem component={Link} key="Informationszentrum" onClick={handleCloseUserMenu} to="/pages/info">
                  <InfoIcon sx={{ mr: 1, color: 'rgba(0, 0, 0, 0.54)' }} />
                  <Typography sx={{ textAlign: 'center' }}>Informationszentrum</Typography>
                </MenuItem>

                {userProfile?.schoolVerified && (userProfile?.schoolProfileComplete || userProfile?.adminProfileComplete) && (
                  <MenuItem component={Link} key="Konfigurator" onClick={handleCloseUserMenu} to="./pages/configurator">
                    <SettingsIcon color="primary" sx={{ mr: 1 }} />
                    <Typography sx={{ textAlign: 'center', color: '#1976d2' }}>Konfigurator</Typography>
                  </MenuItem>
                )}

                {userRole === 'admin' && (
                  <MenuItem component={Link} key="Admin" onClick={handleCloseUserMenu} to="/pages/admin">
                    <AdminPanelSettingsIcon sx={{ mr: 1, color: 'rgba(0, 0, 0, 0.54)' }} />
                    <Typography sx={{ textAlign: 'center' }}>Admin</Typography>
                  </MenuItem>
                )}

                <MenuItem onClick={handleLogout}>
                  <LogoutIcon sx={{ mr: 1, color: 'rgba(255, 0, 0, 0.54)' }} />
                  <Typography sx={{ textAlign: 'center', color: 'red' }}>Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;
